<div class="info-tooltip-container" 
     (mouseenter)="showTooltip()" 
     (mouseleave)="delayHideTooltip()"> 

  <span class="info-icon">
    <i class="mdi mdi-information-outline"></i>
  </span>

  <div class="tooltip-box">
    
    <div class="scrolling-content">
      <p>{{ infoText }}</p>
    </div>
  </div>
</div>